<template>
    <div class="expansion-panels">
        <slot />
    </div>
</template>
<script>
import {provide as RegistrableProvide} from "../../mixins/Registrable";
    import TogglesChildren from "../../mixins/TogglesChildren";
	import {expansionPanelInjection} from "../../types/keys";

    export default {
        name: 'ExpansionPanels',

        mixins: [RegistrableProvide(expansionPanelInjection), TogglesChildren],

        props: {
            // Whether only one child panel can be open at a time
            accordion: {
                type: Boolean,
                default: false
            },

            // Initially opens all child panels
            open: {
                type: Boolean,
                default: false
            },

            // Initially opens the first child panel
            openFirst: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                activeItemValues: this.modelValue ? this.modelValue : (this.toggleMultipleChildren ? [] : null),
                toggleMultipleChildren: !this.accordion
            }
        },

        watch: {
            openFirst() {
                this.openInitialPanels();
            },

            open() {
                this.openInitialPanels();
            },

			items: {
				handler: function () {
					this.openInitialPanels();
				},
				deep: true
			},
        },

		// On mounted to have lazy loaded expansion panels being fully registered, e.g., MembershipPage
        mounted() {
            this.openInitialPanels();
        },

        methods: {
            openInitialPanels() {
                if (this.items && this.items.length && this.openFirst) {
                    this.activeItemValues = this.toggleMultipleChildren ? [this.items[0]._value] : this.items[0]._value;
                } else if (this.items && this.items.length && this.open) {
                    this.activeItemValues = this.toggleMultipleChildren ? this.items.map(item => item._value) : this.items[0]._value;
                } else {
                    this.activeItemValues = this.modelValue ? this.modelValue : (this.toggleMultipleChildren ? [] : null);
                }
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
.description-list + .expansion-panels {
  border-top: 1px solid #e6ecf5;
  margin-top: 16px;
}
</style>